import { ActionsColumn, TABLE_ACTION, TABLE_ACTION_STATE } from '@qrios/frontend-library';

import {
  CustomerValidationBillingResponseItem,
  CustomerValidationBillingTableData,
  CustomerValidationBillingTableRowActions
} from './interfaces';

export const mapApiDataIntoTableFormat = (
  data: CustomerValidationBillingResponseItem[],
  actions: CustomerValidationBillingTableRowActions
): CustomerValidationBillingTableData[] =>
  data.map((customerValidationBillingItem: CustomerValidationBillingResponseItem) => {
    const { cost, id, ...rest } = customerValidationBillingItem;

    const actionsProp = [
      {
        name: TABLE_ACTION.INFO,
        state: TABLE_ACTION_STATE.ACTIVE,
        handler: () => {
          actions.openDetails(id);
        }
      }
    ];

    return {
      ...rest,
      id,
      cost: cost.value,
      actions: <ActionsColumn actions={actionsProp} />
    };
  });
